module.exports = {
	allReportsUrl: `${process.env.REACT_APP_API_BASE_URL}wp/wp-admin/edit.php?post_type=report`,
	apiBaseUrl: `${process.env.REACT_APP_API_BASE_URL}`,
	apiVdV1: `${process.env.REACT_APP_API_BASE_URL}wp-json/vd/v1/`
}